// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-avenue -> repli-sandbox-avenew-avenue -> oneten-royy-avenew-three
// Generated: 2026-10-14T15:27:30.015Z
// Counts: 1 design, 21 content, 5 slot group, 2 collection binding, 7 section, 0 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_full_address"
  },
  "footer.copyright": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_copyright"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_interactivemap_blurb"
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": "virtual tour",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_name"
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "apartment-sync.javascript_id": {
    "overrideType": "VALUE",
    "customValue": "eyJpdiI6ImYyUlVTYkgrTkJreXFCdW4reDdKbHc9PSIsInZhbHVlIjoieGZFZ3JxYnF2NkIyYUt1bHhySVNGQT09IiwibWFjIjoiZWIzYTNlZjEwYjE4ZDIzY2YxZTJlZTM5NTkxN2UyNjlhYWVlMDIwOGNhM2Y5YjJlOTU2YzFiY2NhMTRiNWYyYyJ9",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to 110 Roy, a premier apartment community nestled in the vibrant Lower Queen Anne neighborhood of Seattle, WA. Our thoughtfully designed floor plans include stylish studios, spacious one-bedroom apartments, and versatile two-bedroom options to suit your lifestyle. Experience urban living at its finest with unparalleled access to local entertainment, shopping, restaurants, and nightlife right at your doorstep. Elevate your days with our stunning Rooftop Skyview Terrace, offering breathtaking skyline views, a cozy fire pit, and inviting lounge areas perfect for relaxation or socializing. Fitness enthusiasts will appreciate our well-equipped 24-hour fitness studio, while our resident lounge provides private work-from-home spaces, a pool table, and ample seating for entertaining friends. Stay connected with free WiFi in all common areas and enjoy peace of mind with our advanced video entry system and controlled access garage, which includes guest parking and EV charging options. Your convenience is paramount, with package lockers and designated bike storage with a repair station available for residents. Bring your furry friends along to enjoy our designated rooftop pet area and the self-service Pet Spaw. Explore the beautiful nearby bicycle trail along the Elliott Bay Waterfront and Myrtle Edwards Park, or take advantage of excellent public transportation options. With modern interiors featuring premium stainless-steel appliances, expansive windows, and smart home technology, you’ll find your ideal haven at 110 Roy. Don’t miss out on our unique Avenue5 resident rewards program powered by Bilt! Find your new home today—browse our availability or schedule a tour to visit our community! Experience the perfect blend of luxury, convenience, and location at 11</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to 110 Roy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d6d9d-49a5-7587-b84e-e2aedab919be.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "footer.powered_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d6d9d-fa1c-74bf-a89d-68fd979db7af.webp"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/property/6767906449166921/019e8e0d-9bd3-759e-ac5a-b56d1865baa2.pdf"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.apartmentPhotos": {
    "limit": null,
    "hiddenIds": [
      "custom_8786e9fd-21bc-48b9-9404-f1f59755e23d",
      "custom_734d0139-1107-47f1-9011-fd306976a9a2",
      "custom_bc4b4142-1417-4c09-8a85-3e54c8fde697"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      1,
      2,
      5
    ],
    "ordering": null,
    "customItems": null
  },
  "gallery.images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "image-tracking-pixel",
      "blockId": "image-tracking-pixel",
      "position": 0
    }
  ],
  "floor-plans": [
    {
      "sectionId": "apartment-sync",
      "blockId": "apartment-sync",
      "position": 5
    }
  ]
};

export const styleOverrides = {};
